// extracted by mini-css-extract-plugin
export default {"home":"Home_home__jU5Da","welcome-text":"Home_welcome-text__HTbKX","subtitle":"Home_subtitle__Wm+Py"};